'use client';
/** Конкатенирует переданный набор строк, вставляя между соседними перенос строки. */ const lines = (...raws)=>raws.filter(Boolean).join('\n');

export { lines };
//# sourceMappingURL=lines.js.map
